<!--防伪数据热力图-->
<template>
	<div>
		<h3>防伪数据热力图</h3>
		<div>
            <div class="lines">
                <el-form ref="form" :model="form" inline :rules="rules">
                    <el-form-item prop="date" style="width: 150px;">
						<el-radio-group v-model="form.date">
                            <el-radio-button label="本月"></el-radio-button>
                            <el-radio-button label="本年"></el-radio-button>
                        </el-radio-group>
					</el-form-item>
                    <el-form-item prop="makeTime" style="width: 360px;padding-top: 1px;">
                        <el-date-picker
                        v-model="form.makeTime" clearable
                        type="daterange"
                        range-separator="-"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                        </el-date-picker>
					</el-form-item>
                    <el-form-item prop="productForm.Productname" style="width: 210px;">
						<el-input placeholder="全部商品" :value="form.productForm.Productname" @focus="productfocus"></el-input>
					</el-form-item>
                    <el-button @click="restForm" style="margin-top: 1px;" type="warning">重 置</el-button>
                </el-form>
                <div class="map">
                    <div :style="{height:'500px',width:'49%'}" ref="eChart1" id="echart1"></div>
                    <div :style="{height:'500px',width:'49%',float:'right'}" ref="eChart2" id="echart2"></div>
                </div>
            </div>
            <div style="display:flex">
                <div class="table">
                    <el-button type="primary" style="margin-bottom: 15px;">导出省</el-button>
                    <el-table border>
                        <el-table-column align="center" property="DataId" label="排名"></el-table-column>
                        <el-table-column align="center" property="Productcode" label="省单位"></el-table-column>
                        <el-table-column align="center" property="Productname" label="查询数量"></el-table-column>
                    </el-table>
                </div>
                <div class="table">
                    <el-button type="primary" style="margin-bottom: 15px;">导出市</el-button>
                    <el-table border>
                        <el-table-column align="center" property="DataId" label="排名"></el-table-column>
                        <el-table-column align="center" property="Productcode" label="市单位"></el-table-column>
                        <el-table-column align="center" property="Productname" label="查询数量"></el-table-column>
                    </el-table>
                </div>
            </div>
		</div>
	</div>
</template>

<script>
import echarts from "echarts";//引入图表
import '../../node_modules/echarts/map/js/china.js' // 引入中国地图数据
import '../../node_modules/echarts/map/js/province/anhui.js' // 引入安徽地图数据
import '../../node_modules/echarts/map/js/province/aomen.js' // 引入澳门地图数据
import '../../node_modules/echarts/map/js/province/beijing.js' // 引入北京地图数据
import '../../node_modules/echarts/map/js/province/chongqing.js' // 引入重庆地图数据
import '../../node_modules/echarts/map/js/province/fujian.js' // 引入福建地图数据
import '../../node_modules/echarts/map/js/province/gansu.js' // 引入甘肃地图数据
import '../../node_modules/echarts/map/js/province/guangdong.js' // 引入广东地图数据
import '../../node_modules/echarts/map/js/province/guangxi.js' // 引入广西地图数据
import '../../node_modules/echarts/map/js/province/guizhou.js' // 引入贵州地图数据
import '../../node_modules/echarts/map/js/province/hainan.js' // 引入海南地图数据
import '../../node_modules/echarts/map/js/province/hebei.js' // 引入河北地图数据
import '../../node_modules/echarts/map/js/province/heilongjiang.js' // 引入黑龙江地图数据
import '../../node_modules/echarts/map/js/province/henan.js' // 引入河南地图数据
import '../../node_modules/echarts/map/js/province/hubei.js' // 引入湖北地图数据
import '../../node_modules/echarts/map/js/province/hunan.js' // 引入湖南地图数据
import '../../node_modules/echarts/map/js/province/jiangsu.js' // 引入江苏地图数据
import '../../node_modules/echarts/map/js/province/jiangxi.js' // 引入江西地图数据
import '../../node_modules/echarts/map/js/province/jilin.js' // 引入吉林地图数据
import '../../node_modules/echarts/map/js/province/liaoning.js' // 引入辽宁地图数据
import '../../node_modules/echarts/map/js/province/neimenggu.js' // 引入内蒙古地图数据
import '../../node_modules/echarts/map/js/province/ningxia.js' // 引入宁夏地图数据
import '../../node_modules/echarts/map/js/province/qinghai.js' // 引入青海地图数据
import '../../node_modules/echarts/map/js/province/shandong.js' // 引入山东地图数据
import '../../node_modules/echarts/map/js/province/shanghai.js' // 引入上海地图数据
import '../../node_modules/echarts/map/js/province/shanxi.js' // 引入山西地图数据
import '../../node_modules/echarts/map/js/province/shanxi1.js' // 引入陕西地图数据
import '../../node_modules/echarts/map/js/province/sichuan.js' // 引入四川地图数据
import '../../node_modules/echarts/map/js/province/taiwan.js' // 引入台湾地图数据
import '../../node_modules/echarts/map/js/province/xianggang.js' // 引入香港地图数据
import '../../node_modules/echarts/map/js/province/xinjiang.js' // 引入新疆地图数据
import '../../node_modules/echarts/map/js/province/xizang.js' // 引入西藏地图数据
import '../../node_modules/echarts/map/js/province/yunnan.js' // 引入云南地图数据
import '../../node_modules/echarts/map/js/province/zhejiang.js' // 引入浙江地图数据

export default {
	data(){
		return {
            form:{
                date:'本月',
                makeTime:'',
                productForm:{
					Productcode:'',
					Productname:'',
					Norms:''
				},
            },
            rules: {
        		makeTime:[
          			{ required: true, message: '请选择时间', trigger: 'change' }
        		]
			},
            option1 : {
                tooltip: {}, // 鼠标移到图里面的浮动提示框
                dataRange: {
                    show: false,
                    min: 0,
                    max: 1000,
                    text: ['High', 'Low'],
                    realtime: true,
                    calculable: true,
                    color: ['orangered', 'yellow', 'lightskyblue']
                },
                geo: { // 这个是重点配置区
                    map: 'china', // 表示中国地图
                    zoom:1,
                    roam: false,//支持扩大缩小
                    label: {
                        normal: {
                            show: true, // 是否显示对应地名
                            textStyle: {
                            color: 'rgba(0,0,0,0.6)'
                            }
                        }
                    },
                    itemStyle: {
                        normal: {
                            borderColor: 'rgba(0, 0, 0, 0.4)'
                        },
                        emphasis: {
                            areaColor: null,
                            shadowOffsetX: 0,
                            shadowOffsetY: 0,
                            shadowBlur: 20,
                            borderWidth: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                    }
                },
                series: [{
                    type: 'scatter',
                    selectedMode: 'single',
                    coordinateSystem: 'geo' // 对应上方配置
                    },
                    {
                    name: '数量', // 浮动框的标题
                    type: 'map',
                    geoIndex: 0,
                    data: [{
                        "name": "北京",
                        "value": 599
                    }, {
                        "name": "上海",
                        "value": 142
                    }, {
                        "name": "黑龙江",
                        "value": 44
                    }, {
                        "name": "深圳",
                        "value": 92
                    }, {
                        "name": "湖北",
                        "value": 810
                    }, {
                        "name": "四川",
                        "value": 453
                    },{
                        "name": "湖南",
                        "value": 125
                    }]
                    }
                ]
            },
            option2 : {
                tooltip: {}, // 鼠标移到图里面的浮动提示框
                dataRange: {
                    show: false,
                    min: 0,
                    max: 1000,
                    text: ['High', 'Low'],
                    realtime: true,
                    calculable: true,
                    color: ['orangered', 'yellow', 'lightskyblue']
                },
                geo: { // 这个是重点配置区
                    map: '安徽', // 表示安徽地图
                    zoom:1,
                    roam: false,//支持扩大缩小
                    label: {
                        normal: {
                            show: true, // 是否显示对应地名
                            textStyle: {
                            color: 'rgba(0,0,0,0.6)'
                            }
                        }
                    },
                    itemStyle: {
                        normal: {
                            borderColor: 'rgba(0, 0, 0, 0.4)'
                        },
                        emphasis: {
                            areaColor: null,
                            shadowOffsetX: 0,
                            shadowOffsetY: 0,
                            shadowBlur: 20,
                            borderWidth: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                    }
                },
                series: [
                    {
                        type: 'scatter',
                        coordinateSystem: 'geo' // 对应上方配置
                    },
                    {
                        name: '数量', // 浮动框的标题
                        type: 'map',
                        geoIndex: 0,
                        data: [{
                            "name": "六安市",
                            "value": 599
                        }]
                    }
                ]
            }, 
		};
	},
	mounted : function(){
		var user = JSON.parse(sessionStorage.getItem('user'));
        this.initEcharts()
        
        var elementResizeDetectorMaker = require("element-resize-detector");//导入
        // 创建实例
        var erd = elementResizeDetectorMaker();
        // 创建实例带参
        var erdUltraFast = elementResizeDetectorMaker({
                        strategy: "scroll", //<- For ultra performance.
                        callOnAdd: true,
                        debug: true
                    });
        //监听id为test的元素 大小变化
        erd.listenTo(document.getElementById("echart1"), function(element) {
             let  myChart1 = echarts.init(document.getElementById('echart1'));
             myChart1.resize();
        });
        erd.listenTo(document.getElementById("echart2"), function(element) {
             let  myChart2 = echarts.init(document.getElementById('echart2'));
             myChart2.resize();
        });
        
	},
	methods: {
        //初始化
        initEcharts(){
            let  myChart1 = echarts.init(this.$refs.eChart1);
            myChart1.on("click", this.eChartOnclick);
            myChart1.setOption(this.option1);
            
            let  myChart2 = echarts.init(this.$refs.eChart2);
            myChart2.setOption(this.option2);
        },
        productfocus(){//获取商品
			this.productVisible=true;
			var user = JSON.parse(sessionStorage.getItem('user'));
			this.$axios({
				method: 'post',
				url:'/FW/Product.ashx',
				params: {
					action:"query",
					cid:user.QyNum
				}
				}).then(res=>{
				if(res.Code==0){
					this.productData=res.DataList;
				}else{
					this.$message({
					showClose: true,
					message: res.Msg,
					type: "warning"
					});
				}      
			})
        },
        eChartOnclick(param){
            this.option2.geo.map=param.name
            console.log(param.name)
            let  myChart2 = echarts.init(this.$refs.eChart2);
            myChart2.setOption(this.option2);
        },
        restForm(){//重置表单
			this.$nextTick(()=>{
				this.$refs['form'].resetFields()
			})
			this.form.productForm.Productcode = '';
			this.form.productForm.Productname = '';
			this.form.productForm.Norms = '';
		},
	}
}
</script>

<style scoped>
.lines{
    width: 100%;
    background: #f8f8f8;
    padding: 10px;
    margin-bottom: 20px;
}
.map{
    margin-top: 20px;
    padding: 10px 10px;
    background: #f8f8f8;
    overflow:hidden;
    zoom:1;
}
.map div{
    float: left;
}
.table{
    flex:1;
    padding: 10px;
    background: #f8f8f8;
}
</style>


// WEBPACK FOOTER //
// src/pages/fwArea.vue